"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decisionOutputSchema = void 0;
var problem_schema_1 = require("./problem-schema");
exports.decisionOutputSchema = {
    type: ['object', 'null'],
    required: [],
    properties: {
        scorecardLoanToValueRatio1: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        loanStatusCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters or null',
            default: '',
        },
        errors: {
            type: ['array', 'null'],
            items: problem_schema_1.problemSchema,
        },
        lowRatioInsurableAge: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        lowRatioAgeRangeTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 16,
            errorMessage: 'should have maximum length of 16 characters or null',
            default: '',
        },
        lesserPremiumIndicator: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 16,
            errorMessage: 'should have maximum length of 16 characters or null',
            default: '',
        },
        loanToValueRatioPercent: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        revisedPriceIndexLtvPercentage: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        revisedLendingValueAmount: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        firstMrtgOSBalAtSecondMrtg: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        averagePoolInterestRate: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        loanFullTopUpAmortizationDate: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        lenderPortfolioLoanAmount: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        lenderPortfolioMortgageCount: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        masterPoolCMHCAccountnumber: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        poolBundleTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 16,
            errorMessage: 'should have maximum length of 16 characters or null',
            default: '',
        },
        loanTermPeriod: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        helocUsagePercentage: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        yearAndMonthSinceFirstTrade: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        monthsInArrears: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        originalClaimPaid: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        mifCoreIndicator: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 32,
            errorMessage: 'should have maximum length of 32 characters or null',
            default: '',
        },
        grossSaleProceeds: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        guaranteedLoanFlag: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 32,
            errorMessage: 'should have maximum length of 32 characters or null',
            default: '',
        },
    },
};
exports.default = exports.decisionOutputSchema;
